import React from 'react'
import { FormGroup, FormControl, Checkbox, Col, Row } from 'react-bootstrap'

function NoWaitlistTransFields(props) {
  const { disabled, resetPricingBreakdown, organization_merch, selected_program } = props
  return (
    <>
      <Row className="enrolment-row">
        <FormGroup className="merch-display">
          {
            selected_program.item_0_cost !== null && organization_merch[0] ? (
              <Col lg={4} xs={12}>
              <Checkbox
                className="checkbox"
                inline name="item_0"
                id="item_0"
                onChange={resetPricingBreakdown}
                disabled={disabled}>
                <img className="checkbox-img" alt="merch" src={organization_merch[0].logo}/>
                  <div>
                    ${selected_program.item_0_cost}&nbsp;&nbsp;
                  </div>
                  <div>
                    <FormControl className="opaque-grey formcontrol-width" name="item_0_size" id="item_0_size" componentClass="select" style={{ width: "auto"}} disabled={disabled}>
                      {props.item_0_options}
                    </FormControl>
                  </div>
              </Checkbox>
              </Col>
            ) : ""
          }
          {
            selected_program.item_1_cost !== null && organization_merch[1] ? (
              <Col lg={4} xs={12}>
              <Checkbox 
              className="checkbox" 
              inline name="item_1" 
              id="item_1" 
              onChange={resetPricingBreakdown} 
              disabled={disabled}>
                <img className="checkbox-img" alt="merch" src={organization_merch[1].logo} />
                <div>
                  ${selected_program.item_1_cost}&nbsp;&nbsp;
                </div>
                <div>
                  <FormControl className="opaque-grey formcontrol-width" name="item_1_size" id="item_1_size" componentClass="select" style={{ width: "auto"}} disabled={disabled} >
                    {props.item_1_options}
                  </FormControl>
                </div>
              </Checkbox>
              </Col>
            ) : ""
            }
          {
            selected_program.item_2_cost !== null && organization_merch[2] ? (
              <Col lg={4} xs={12}>
              <Checkbox className= "checkbox" inline name="item_2" id="item_2" onChange={resetPricingBreakdown} disabled={disabled}>
                <img className="checkbox-img" alt="merch" src={organization_merch[2].logo} />
                <div>
                  ${selected_program.item_2_cost}&nbsp;&nbsp;
                </div>
                <div>
                  <FormControl className="opaque-grey formcontrol-width" name="item_2_size" id="item_2_size" componentClass="select" style={{ width: "auto"}} disabled={disabled} >
                    {props.item_2_options}
                  </FormControl>
                </div>
              </Checkbox>
              </Col>
            ) : ""
            }
        </FormGroup>

      </Row>
    </>
  )
}

export default NoWaitlistTransFields
